import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { AcuerdoIndirectoControllerService, ApiAcuerdosGestores, CodigoLerControllerService, PoseedorControllerService, PoseedorFilterDTO } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { ManagersAgreementsAddModalComponent } from '../managers-agreements-add-modal/managers-agreements-add-modal.component';
import { ManagersAgreementsHoldersRelationModalComponent } from '../managers-agreements-holders-relation-modal/managers-agreements-holders-relation-modal.component';
import { IndirectAgreementUploadAgreementModalComponent } from '../indirect-agreement-upload-agreement-modal/indirect-agreement-upload-agreement-modal.component';
import { IndirectAgreementCodLerModalComponent } from '../indirect-agreement-cod-ler-modal/indirect-agreement-cod-ler-modal.component';
import { ManagersAgreementsGenerateConsentModalComponent } from '../managers-agreements-generate-consent-modal/managers-agreements-generate-consent-modal.component';
import { ManagersAgreementsConsentHoldersModalComponent } from '../managers-agreements-consent-holders-modal/managers-agreements-consent-holders-modal.component';
import { DownloadService } from '../../services/download.service';

const ESTADO_BAJA = 6;

@Component({
  selector: 'managers-agreements-holders',
  templateUrl: './managers-agreements-holders.component.html',
  styleUrls: ['./managers-agreements-holders.component.scss']
})
export class ManagersAgreementsHoldersComponent implements OnInit, OnChanges {
  @Input() acuerdoIndirectoInfo!: any;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();

  searchForm!: FormGroup;
  gestorControl: FormControl = new FormControl(null);
  poseedorControl: FormControl = new FormControl(null);
  pageNumber = 1;
  pageSize = 25;
  recordsTotal = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage = 25;

  gestoresDelAcuerdo: any[] = [];
  poseedoresDelAcuerdo: any[] = [];
  estadosPoseedorAcuerdo: ApiAcuerdosGestores.AcuerdoIndirectoEstadoDTO[] = [];
  codigosLerArray: any[] = [];

  gestoresEndpoint: string = this.environment.urlBackCore + 'api/v1/acuerdos-gestores/gestores';
  poseedorEndpoint: string =
    this.environment.urlBackPoseedores + `api/v1/poseedores/poseedor`;
  gridArray: ApiAcuerdosGestores.PoseedoresAcuerdoDTO[] = [];

  headArray: any[] = [
      {
      Head: 'Documento',
      FieldName: 'codigoDocumento',
    },
    {
      Head: 'Razón social',
      FieldName: 'razonSocial',
      Tooltip: true,
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle códigos LER',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'ver_acuerdo',
          icon: 'download',
          toolTip: 'Descargar consentimiento',
          show: {
            params: 'canViewAgreement',
            accion: 'ver_acuerdo',
          },
        },
        {
          nameButton: 'subir_acuerdo',
          icon: 'upload',
          toolTip: 'Subir consentimiento firmado',
          show: {
            params: 'canUploadAgreement',
            accion: 'subir_acuerdo',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'generar_consentimiento',
              name: 'Generar contrato de consentimiento',
              show: {
                params: 'canGenerateAneex3',
                accion: 'generar_consentimiento',
              },
            },
            {
              nameButton: 'validar_anexo',
              name: 'Validar consentimiento',
              show: {
                params: 'canValidateAnnex',
                accion: 'validar_anexo',
              },
            },
             {
              nameButton: 'rechazar_anexo',
              name: 'Rechazar consentimiento',
              show: {
                params: 'canRejectAnnex',
                accion: 'rechazar_anexo',
              },
            },
            {
              nameButton: 'dar_de_baja',
              name: 'Dar de baja',
              show: {
                params: 'canDarDeBaja',
                accion: 'dar_de_baja',
              },
            },
            {
              nameButton: 'modificar_nimas',
              name: 'Modificar NIMAs del consentimiento',
              show: {
                params: 'canModifyNimas',
                accion: 'modificar_nimas',
              },
            },
            {
              nameButton: 'modificar_codigos_ler',
              name: 'Modificar codigos ler',
              show: {
                params: 'canModifyCodigosLer',
                accion: 'modificar_codigos_ler',
              },
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];
  updateList: boolean = false;
  defaultFilter: boolean = true;
  urlBackValidar: string = this.environment.urlBackAcuerdoIndirecto + 'api/v1/acuerdos-gestores/gestores';
  constructor(
    @Inject('environment') private environment: any,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private http: HttpClient,

    private codigoLerService: CodigoLerControllerService,
    private acuerdoIndirectoControllerSrv: AcuerdoIndirectoControllerService,
    private poseedorControllerService: PoseedorControllerService,
    private downloadSrv: DownloadService,
      @Inject(ApiAcuerdosGestores.ConsentimientoControllerService)
      private consentimientoControllerSrv: ApiAcuerdosGestores.ConsentimientoControllerService,
      @Inject(ApiAcuerdosGestores.ConsentimientoEstadosControllerService)
      private consentimientoEstadosControllerSrv: ApiAcuerdosGestores.ConsentimientoEstadosControllerService,
            //private poseedoresAcuerdoControllerSrv: ApiAcuerdosGestores.PoseedoresAcuerdoControllerService,

  ) {
    this.searchForm = this.formBuilder.group({
      gestor: this.gestorControl,
      poseedor: this.poseedorControl,
      documento: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
      peligrosidad: [{ value: null, disabled: false }],
    });
    
  }

  ngOnInit(): void {
    this.cargarCombos();
    this.cargarGestoresAcuerdo();
    this.cargarPoseedoresAcuerdo();
    this.searchData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['acuerdoIndirectoInfo']?.currentValue) {
      this.cargarGestoresAcuerdo();
      this.cargarPoseedoresAcuerdo();
      this.searchData();
    }
  }

  cargarCombos(): void {
    this.consentimientoEstadosControllerSrv.findAll6().subscribe({
      next: (data) => {
        this.estadosPoseedorAcuerdo = data ?? [];
      },
      error: () => {
        this.estadosPoseedorAcuerdo = [];
      },
    });

    this.codigoLerService.findAll4({ acuerdoGestores: true }, { page: 0, size: 1000 }).subscribe({
      next: (data: any) => {
        this.codigosLerArray = data?.datos ?? [];
      },
      error: () => {
        this.codigosLerArray = [];
      },
    });
  }

  cargarGestoresAcuerdo(): void {
    const gestores = this.acuerdoIndirectoInfo?.gestoresResiduos ?? [];
    this.gestoresDelAcuerdo = gestores.map((gestor: any) => ({
      ...gestor,
      displayName: [gestor?.nima, gestor?.razonSocial, gestor?.centro].filter(Boolean).join(' - '),
    }));
  }

  private cargarPoseedoresAcuerdo(selectedPoseedorId?: number): void {
    if (!this.acuerdoIndirectoInfo?.id) {
      this.poseedoresDelAcuerdo = [];
      return;
    }

    const filtro: PoseedorFilterDTO = {
      estado: { id: ['1,2,3,4,6,7,8'] }, // Filtrar por estado activo
     };

    this.poseedorControllerService.findAll5(filtro, { page: 0, size: 1000, sort: ['id,desc'] }).subscribe({
      next: (data: any) => {
        // const rows = data?.datos ?? [];
        // const byId = new Map<number, any>();
        // rows.forEach((row: any) => {
        //   const poseedor = row?.poseedor;
        //   if (poseedor?.id) {
        //     byId.set(poseedor.id, poseedor);
        //   }
        // });
        // this.poseedoresDelAcuerdo = Array.from(byId.values());
        this.poseedoresDelAcuerdo =  data?.datos ?? [];

        if (selectedPoseedorId) {
          const selectedPoseedor = this.poseedoresDelAcuerdo.find((p: any) => p?.id === selectedPoseedorId);
          if (selectedPoseedor) {
            this.poseedorControl.setValue(selectedPoseedor, { emitEvent: false });
            this.searchForm.get('poseedor')?.setValue(selectedPoseedor, { emitEvent: false });
          }
        }
      },
      error: () => {
        this.poseedoresDelAcuerdo = [];
      },
    });
  }

  isGestorUser(): boolean {
    return this.canViewResource('AI-GESTOR');
  }

  canEditSection(): boolean {
    const hasPermission = this.canViewResource('AI-ENV-GEST') || this.canViewResource('AI-GESTOR') || this.authService.can('acuerdo-indirecto-di-detalle', 'access-update');
    return hasPermission && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  getPoseedorDescription(obj: any) {
    if (!obj) {
      return '';
    }
    const razonSocial = obj.razonSocial ?? obj.poseedor?.razonSocial;
    const nima = obj.nima ?? obj.poseedor?.nima;
    const centro = obj.denominacionCentro ?? obj.poseedor?.denominacionCentro ?? obj.centro;
    return [razonSocial, nima, centro].filter((value: any) => !!value).join(' - ');
  }

  getObjectQuery(searchterm: string) {
    return {
      razonSocial: searchterm,
      nima: searchterm,
      codigoDocumento: searchterm,
    };
  }

  getGestorDescription(obj: any) {
    if (!obj) {
      return '';
    }
    const razonSocial = obj.razonSocial ?? obj.gestor?.razonSocial;
    const nima = obj.nima ?? obj.gestor?.nima;
    const centro = obj.centro ?? obj.gestor?.centro;
    return [razonSocial, nima, centro].filter((value: any) => !!value).join(' - ');
  }

  compareById(a: any, b: any): boolean {
    if (!a || !b) {
      return a === b;
    }
    return a.id === b.id;
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocial: searchterm,
      nima: searchterm,
      codigoDocumento: searchterm,
    };
  }

  onGestorSelected(gestor: any): void {
    const selectedGestor = gestor ?? this.gestorControl.value;
    if (!selectedGestor) {
      return;
    }
    this.gestorControl.setValue(selectedGestor, { emitEvent: false });
    this.searchForm.get('gestor')?.setValue(selectedGestor, { emitEvent: false });
  }

  onPoseedorSelected(poseedor: any): void {
    const selectedPoseedor = poseedor ?? this.poseedorControl.value;
    if (!selectedPoseedor) {
      return;
    }
    this.poseedorControl.setValue(selectedPoseedor, { emitEvent: false });
    this.searchForm.get('poseedor')?.setValue(selectedPoseedor, { emitEvent: false });
  }

  searchData(): void {
    this.pageNumber = 1;
    this.buscarRelaciones();
  }

  clearSearcher(): void {
    this.searchForm.reset();
    this.gestorControl.setValue(null);
    this.poseedorControl.setValue(null);
    this.buscarRelaciones();
  }

  buscarRelaciones(): void {
    if (!this.acuerdoIndirectoInfo?.id) {
      this.gridArray = [];
      this.recordsTotal = 0;
      return;
    }

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const gestor = this.searchForm.get('gestor')?.value;
    const poseedor = this.searchForm.get('poseedor')?.value;
    const documento = this.searchForm.get('documento')?.value;
    const estado = this.searchForm.get('estado')?.value;
    const codigoLer = this.searchForm.get('codigoLer')?.value;
    const peligrosidad = this.searchForm.get('peligrosidad')?.value;

    const filtro: ApiAcuerdosGestores.ConsentimientoFilterDTO = {
      documento: documento?.toString().trim().toUpperCase() || undefined,
      estado: estado?.id ? { id: estado.id } : undefined,
      codigoLer: codigoLer?.id ? { id: codigoLer.id } as any : undefined,
    } as any;
    (filtro as any).acuerdoIndirecto = { id: this.acuerdoIndirectoInfo.id };

    this.spinnerSrv.loadingShow();
    this.consentimientoControllerSrv.findAll5(filtro, { page, size: this.pageSize, sort: ['id,desc'] }).subscribe({
      next: (data: any) => {
        this.spinnerSrv.loadingHide();
        let result = data?.datos ?? [];
        const documentoNormalizado = (documento ?? '').toString().trim().toUpperCase();
        if (documentoNormalizado) {
          result = result.filter((item: any) => {
            const codigoDocumento = (item?.poseedor?.codigoDocumento ?? '').toString().trim().toUpperCase();
            return codigoDocumento.includes(documentoNormalizado);
          });
        }
        if (peligrosidad !== null && peligrosidad !== undefined) {
          result = result.filter((item: any) => (item?.codigoLer ?? []).some((ler: any) => !!ler?.peligrosidad) === peligrosidad);
        }
        this.gridArray = this.canAccessAll(result);
        this.recordsTotal = data?.paginacion?.totalElements ?? this.gridArray.length;
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al obtener poseedores con acuerdo', 'error');
      },
    });
  }

  canAccessAll(list: any[]) {
    const isEnvaloraManagerRole = this.canViewResource('AI-ENV-GEST');
    return list.map((objeto: any) => ({
      ...objeto,
      canAccessView: true,
      canViewAgreement: objeto?.estado?.id === 3 || objeto?.estado?.id === 4 || objeto?.estado?.id === 5 || objeto?.estado?.id === 6,
      canGenerateAgreement: objeto?.estado?.id === 2,
      canUploadAgreement: objeto?.estado?.id === 3,
      canValidateAnnex: objeto?.estado?.id === 4 && isEnvaloraManagerRole,
      canGenerateAneex3: objeto?.estado?.id === 2,
      canRejectAnnex: objeto?.estado?.id === 4 && isEnvaloraManagerRole,
      canDarDeBaja: objeto?.estado?.id !== ESTADO_BAJA,
      canModifyNimas: objeto?.estado?.id !== ESTADO_BAJA,
      canModifyCodigosLer: objeto?.estado?.id === 2,
    }));
  }

  private isGenerarConsentimientoState(estado: any): boolean {
    return estado?.id === 2;
  }

  action(item: any): void {
    if (item?.nameButton === 'view') {
      this.openModalCodLer(item);
    } else if (item?.nameButton === 'generar_acuerdo') {
      this.generarAcuerdo(item);
    } else if (item?.nameButton === 'validar_anexo') {
      this.validarAnexo3(item);
    } else if (item?.nameButton === 'ver_acuerdo') {
      // TODO: Implementar la lógica para descargar el acuerdo. Actualmente, esta acción está comentada y no realiza ninguna operación.
      //  TODO: EN FUNCION DEL ESTADO DE POSEEDOR SE DESCARGA UN ANEXO U OTRO
      //const url = `${this.environment.urlBackAcuerdosGestores}api/v1/acuerdo-indirecto/${item.id}/exportar`;
      //window.open(url, '_blank');
      this.descargarAnexo(item);
    } else if (item?.nameButton === 'subir_acuerdo') {
      // TODO: Implementar la lógica para subir el acuerdo. Actualmente, esta acción está comentada y no realiza ninguna operación.
      this.subirAcuerdo(item);
    } else if (item?.nameButton === 'generar_consentimiento') {
      this.generarConsentimiento(item);
    } else if (item?.nameButton === 'modificar_nimas') {
      this.modificarNimasConsentimiento(item);
    } else if (item?.nameButton === 'modificar_codigos_ler') {
      this.modificarCodigosLerConsentimiento(item);
    }
    else if (item?.nameButton === 'rechazar_anexo') {
      this.rechazarAnexo(item);
    } else if (item?.nameButton === 'dar_de_baja') {
      this.darDeBaja(item);
    }
  }

  openModalCodLer(item: any): void {
    const dialogRef = this.dialog.open(IndirectAgreementCodLerModalComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        relacion: item,
        soloLectura: this.acuerdoIndirectoInfo?.estado?.id === ESTADO_BAJA,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.buscarRelaciones();
      }
    });
  }

  openModalPoseedorNoRegistrado(): void {
    const dialogRef = this.dialog.open(ManagersAgreementsAddModalComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.createdPoseedor) {
        this.cargarPoseedoresAcuerdo(result.createdPoseedor?.id);
      }
    });
  }

  openModalRelacion(item?: any, onlyView: boolean = false): void {
    const gestor = this.searchForm.get('gestor')?.value;
    const poseedor = this.searchForm.get('poseedor')?.value;

    // if (!onlyView && (!gestor?.id || !poseedor?.id)) {
    //   this.snackBarSrv.showSnackBar('Debe seleccionar gestor y poseedor para añadir la relación', 'error');
    //   return;
    // }

    const dialogRef = this.dialog.open(ManagersAgreementsHoldersRelationModalComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
        relacion: item,
        onlyView,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.buscarRelaciones();
        this.refrescarAdheridoEvent.emit(true);
      }
    });
  }

  renderPage(event: number): void {
    this.pageNumber = event;
    this.buscarRelaciones();
  }

  onItemsPerPageChange(): void {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  private refreshAgreementAndRelations(): void {
    this.buscarRelaciones();
    this.cargarPoseedoresAcuerdo();
    this.refrescarAdheridoEvent.emit(true);
  }

  hasMultiplePages(): boolean {
    const total = this.recordsTotal ?? 0;
    const size = this.pageSize ?? 0;
    return size > 0 && total > size;
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      case 'poseedor': {
        return this.searchForm.get('poseedor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  selectedModel(selectForm: any) {
    switch (selectForm) {
      case 'poseedor': {
        break;
      }
      default: {
        break;
      }
    }
  }
  filterList(selectForm: any) {
    switch (selectForm) {
      case 'poseedor': {
        return this.searchForm.get('poseedor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }
  generarAcuerdo(item: any): void {
    this.spinnerSrv.loadingShow();
    this.acuerdoIndirectoControllerSrv.generarAcuerdo(item.id).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Acuerdo generado correctamente', 'success');
        this.refreshAgreementAndRelations();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al generar el acuerdo', 'error');
      }
    });
  }
  subirAcuerdo(item: any): void {
    const dialogRef = this.dialog.open(IndirectAgreementUploadAgreementModalComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
        gestor: item?.gestor,
        poseedor: item?.poseedor,
        relacion: item,
        onlyView: false,
        poseedorAcuerdo: item,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.buscarRelaciones();
        this.refrescarAdheridoEvent.emit(true);
        this.refreshAgreementAndRelations();
      }
    });
  }

  validarAnexo3(item: any): void {
     const poseedorAcuerdo = { ...item, estado: { id: 5 } };
    this.spinnerSrv.loadingShow();
     this.consentimientoControllerSrv.updateById1(item.id, poseedorAcuerdo).subscribe({
       next: () => {
         this.spinnerSrv.loadingHide();
         this.snackBarSrv.showSnackBar('Consentimiento validado correctamente', 'success');
         this.refreshAgreementAndRelations();
       },
       error: () => {
         this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al validar el consentimiento', 'error');
       }
     });
  }
  // generarAnexo3(item: any): void {
  //   if (!item?.id) {
  //     //this.snackBarSrv.showSnackBar('No se puede generar el consentimiento: relación inválida', 'error');
  //     return;
  //   }
  //   this.spinnerSrv.loadingShow();
  //   this.poseedoresAcuerdoControllerSrv.generarAnexo3(item.id).subscribe({
  //     next: () => {
  //       this.spinnerSrv.loadingHide();
  //       this.snackBarSrv.showSnackBar('Consentimiento generado correctamente', 'success');
  //       this.refreshAgreementAndRelations();
  //     },
  //     error: () => {
  //       this.spinnerSrv.loadingHide();
  //       this.snackBarSrv.showSnackBar('Ha ocurrido un error al generar el consentimiento', 'error');
  //     }
  //   });
  // }
  rechazarAnexo(item: any): void {
    if (!item?.id) {
      //this.snackBarSrv.showSnackBar('No se puede gestionar el consentimiento: relación inválida', 'error');
      return;
    }
    const poseedorAcuerdo = { ...item, estado: { id: 3 } };
    this.spinnerSrv.loadingShow();
    this.consentimientoControllerSrv.updateById1(item.id, poseedorAcuerdo).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Consentimiento rechazado correctamente', 'success');
        this.refreshAgreementAndRelations();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al rechazar el consentimiento', 'error');
      }
    });
  }


   descargarAnexo(item: any): void {
     // if (!item?.id) {
     //   this.snackBarSrv.showSnackBar('No se puede descargar el consentimiento: relación inválida', 'error');
       ////}
     this.spinnerSrv.loadingShow();
     this.consentimientoControllerSrv.descargarConsentimiento(+item.id).subscribe({
           next: (response) => {
             this.spinnerSrv.loadingHide();
             this.snackBarSrv.showSnackBar(
               'Se ha descargado el consentimiento correctamente',
               'success'
             );
             const defaultFileName = `${this.getConsentimientoDocumentName(item)}.pdf`;
             const fileName = (item?.documentoFirmado?.nombre || item?.documentoPendienteFirma?.nombre || defaultFileName).toString().trim();
             this.downloadSrv.downloadBlob(response, fileName);
         
           },
           error: (err) => {
             this.spinnerSrv.loadingHide();
             this.snackBarSrv.showSnackBar(
               'Ha ocurrido un error al descargar el consentimiento',
               'error'
             );
           },
         });
   }

    darDeBaja(item: any): void {
    if (!item?.id) {
      return;
    }
    const poseedorAcuerdo = { ...item, estado: { id: ESTADO_BAJA } };
    this.spinnerSrv.loadingShow();
    this.consentimientoControllerSrv.updateById1(item.id, poseedorAcuerdo).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Poseedor dado de baja correctamente', 'success');
        this.refreshAgreementAndRelations();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al dar de baja el poseedor', 'error');
      }
    });
  }
  generarConsentimiento(item: any): void {
    if (!item?.id) {
      this.snackBarSrv.showSnackBar('No se pudo identificar el consentimiento', 'error');
      return;
    }

    const dialogRef = this.dialog.open(ManagersAgreementsGenerateConsentModalComponent, {
      width: '920px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        consentimiento: item,
        acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.refreshAgreementAndRelations();
      }
    });
  }

  modificarNimasConsentimiento(item: any): void {
    if (!item?.id) {
      this.snackBarSrv.showSnackBar('No se pudo identificar el consentimiento', 'error');
      return;
    }

    const dialogRef = this.dialog.open(ManagersAgreementsConsentHoldersModalComponent, {
      width: '980px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        consentimiento: item,
        poseedoresDisponibles: this.poseedoresDelAcuerdo ?? [],
        acuerdoIndirecto: this.acuerdoIndirectoInfo,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.refreshAgreementAndRelations();
      }
    });
  }

  modificarCodigosLerConsentimiento(item: any): void {
    if (!item?.id) {
      this.snackBarSrv.showSnackBar('No se pudo identificar el consentimiento', 'error');
      return;
    }

    if (!this.isGenerarConsentimientoState(item?.estado)) {
      this.snackBarSrv.showSnackBar('Solo se pueden modificar códigos LER en estado Generar consentimiento', 'error');
      return;
    }

    const dialogRef = this.dialog.open(IndirectAgreementCodLerModalComponent, {
      width: '980px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        relacion: item,
        consentimiento: item,
        codigosLerDisponibles: this.codigosLerArray ?? [],
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.refreshAgreementAndRelations();
      }
    });
  }

  private getConsentimientoDocumentName(item: any): string {
    const cifAcuerdo = this.normalizeDocumentCode(
      this.acuerdoIndirectoInfo?.codigoDocumento ?? item?.acuerdoIndirecto?.codigoDocumento
    );
    const cifPoseedor = this.normalizeDocumentCode(
      item?.poseedor?.codigoDocumento ?? item?.codigoDocumento
    );
    return `Consentimiento_${cifAcuerdo || 'CIF_ACUERDO'}_${cifPoseedor || 'CIF_POSEEDOR'}`;
  }

  private normalizeDocumentCode(value: any): string {
    return (value ?? '')
      .toString()
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
  }
}
